import { render, staticRenderFns } from "./NewHotSign.vue?vue&type=template&id=f05c4df6&scoped=true&lang=pug&"
import script from "./NewHotSign.vue?vue&type=script&lang=js&"
export * from "./NewHotSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05c4df6",
  null
  
)

export default component.exports